import mobileAndroid from './mobileAndroid.png'
import mobileIOS from './mobileIOS.png'

export default { mobileAndroid, mobileIOS }

export const TriggerByCodeStaticImages = {
  mobileAndroid, mobileIOS
};